import React from 'react';

import { AlertDialog } from '../widgets';
import { t } from './i18n';

/**
 * ErrorBoundary: catches React render/lifecycle errors in children,
 * shows a blocking dialog, then reloads the app (safe reset).
 *
 * No redux, no landingPage routing.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      openAlert: false
    };
  }

  componentDidCatch(error, info) {
    // Optional: console logging, or wire to your telemetry service
    console.error('UI error caught by ErrorBoundary:', error, info);

    this.setState({
      hasError: true,
      openAlert: true
    });
  }

  reset = () => {
    // Hard reset is the most reliable recovery in a metadata-driven SPA
    // when a render-time exception occurs.
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <>
          <AlertDialog
            confirmMessage={t`An unexpected error occurred. Please refresh the page.`}
            handleClose={this.reset}
            open={this.state.openAlert}
            agree={this.reset}
            noCancel={true}
          />
        </>
      );
    }

    return this.props.children;
  }
}
